const callLocations: { [index: string]: true | undefined } = {};

/**
 * Logs a warning to the console once and ignores subsequent request from the same caller.
 */
export function warnOnce(message?: any, ...optionalParams: any[]): void {
	const trace = (new Error().stack ?? 'Error\n\n<unknown>').split('\n')[2].trim();

	if (!callLocations[trace]) {
		callLocations[trace] = true;
		console.warn(message, ...optionalParams);
	}
}
